<template>
    <div>
        <div class="flex-grid a-form-inputs">
            <div class="flex-grid__item">
                <control label="Select Ogden Table Discount Rate">
                    <select v-model="discountRate">
                        <option :value="-2.0">-2.00%</option>
                        <option :value="-1.5">-1.50%</option>
                        <option :value="-1.0">-1.00%</option>
                        <option :value="-0.75">-0.75%</option>
                        <option :value="-0.5">-0.50%</option>
                        <option :value="-0.25">-0.25%</option>
                        <option :value="0.0">0.00%</option>
                        <option :value="0.5">0.50%</option>
                        <option :value="1.0">1.00%</option>
                        <option :value="1.5">1.50%</option>
                        <option :value="2.0">2.00%</option>
                        <option :value="2.5">2.50%</option>
                        <option :value="3.0">3.00%</option>
                    </select>
                </control>
                <control label="Assumed Settlement"
                         for="assumed_settlement">
                    <input autocomplete="off" type="text" :value="claimDetails('assumedSettlement')" readonly disabled/>
                </control>
                <control label="Period Between DOD & Settlement"
                         for="period_between_dod_and_settlement"
                         before-after="years">
                    <input autocomplete="off" readonly disabled type="text" :value="deceasedDetails('periodDeathToSettlement')"
                           id="period_between_dod_and_settlement"/>
                </control>
                <control label="Deceased's Age at Assumed Settlement"
                         for="deceased_age_at_settlement">
                    <input autocomplete="off" readonly disabled type="text" :value="deceasedDetails('ageAtSettlement')"
                           id="deceased_age_at_settlement"/>
                </control>
                <control label="Period from Settlement to End of Dependency" before-after="years">
                    <input autocomplete="off" readonly disabled type="text" :value="roundValue(periodSettlementToEnd,2)"
                           id="period_from_settlement_to_end_of_dependency"/>
                </control>
            </div>
            <div class="flex-grid__item flex-grid--space-left">
                <control label="Select Ogden Table">
                    <select v-model="discountTable">
                        <option :value="1">Table 1 or 2</option>
                        <option :value="28">Table 36</option>
                    </select>
                </control>
                <control :label="table1Or2Label"
                         for="ogden_table_multiplier"
                         v-if="discountTable === 1"
                         :tip-icon="'formula'"
                         tip-text="Click to view calculation"
                         tip-side="left"
                         tip-width="140"
                         tip-name="ogden_table_multiplier_1"
                         :modal-name="'multipliers_' + uniqueId"
                         :endpoint="'table1and2'"
                         :payload="multiplierPayload">
                    <input autocomplete="off" readonly disabled type="text" :value="multipliers.table1Or2Multiplier" v-two-dp>
                </control>
                <control label="Ogden Table 36 Multiplier"
                         for="ogden_table_multiplier"
                         v-if="discountTable === 28"
                         :tip-icon="'formula'"
                         tip-text="Click to view calculation"
                         tip-side="left"
                         tip-width="140"
                         tip-name="ogden_table_multiplier_28"
                         :modal-name="'multipliers_' + uniqueId"
                         :endpoint="'table28'"
                         :payload="multiplierPayload">
                    <input autocomplete="off" readonly disabled type="text" :value="multipliers.table28Multiplier" v-two-dp>
                </control>
                <control label="Ogden Table E Pre-Assessment Discount"
                         for="ogden_table_pre_assesmentment"
                         :tip-icon="'formula'"
                         tip-text="Click to view calculation"
                         tip-side="left"
                         tip-width="140"
                         tip-name="ogden_table_pre_assesmentment"
                         :modal-name="'multipliers_' + uniqueId"
                         :endpoint="'pre'"
                         :payload="preAndPostAssessmentPayload">
                    <input autocomplete="off" readonly disabled type="text" :value="multipliers.preAssessmentDiscount" v-two-dp>
                </control>
                <control label="Ogden Table F Post-Assessment Discount"
                         for="ogden_table_post_assesmentment"
                         :tip-icon="'formula'"
                         tip-text="Click to view calculation"
                         tip-side="left"
                         tip-width="140"
                         tip-name="ogden_table_post_assesmentment"
                         :modal-name="'multipliers_' + uniqueId"
                         :endpoint="'post'"
                         :payload="preAndPostAssessmentPayload">
                    <input autocomplete="off" readonly disabled type="text" :value="multipliers.postAssessmentDiscount" v-two-dp>
                </control>
                <control label="Calculated Income Dependency"
                         for="calculated_income_dod"
                         before-after="pound">
                    <input autocomplete="off" readonly disabled type="text" :value="currencyFormat(calculatedIncomeDependency, '')">
                </control>
            </div>
        </div>
        <div class="a-table a-table--short-no-style a-table--really-wide" v-if="discountTable === 28">
            <div :class="{ 'a-loader--table' : !multiplierTable.length }"></div>
            <table cellspacing="0" cellpadding="0" v-if="multiplierTable.length">
                <thead>
                <tr>
                    <th>Period</th>
                    <th colspan="2">Dates (from&ndash;to)</th>
                    <th>Duration (years)</th>
                    <th>Number of Dependants</th>
                    <th v-if="theMultiplicand.method != 'multiplicand_pounds'">Dependency Formula</th>
                    <th>Dependency Multiplicand</th>
                    <th>Multiplier</th>
                    <th>Discount Factor</th>
                    <th v-if="theDeceased.income.contingencyMultiplier">Employment Contingency Multiplier</th>
                    <th>Discounted Multiplier</th>
                    <th>Dependency Value</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in multiplierTable">
                    <th>{{ row.period =='pre' ? 'Pre-Assessment' : 'Post-Assessment'}}</th>
                    <td>{{ row.start }}</td>
                    <td>{{ row.end }}</td>
                    <td>{{ roundValue(row.duration,2) }}</td>
                    <td>{{ row.numberOfDependants }}</td>
                    <td v-if="theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants == 1">
                        <svg version="1.1" x="0px" y="0px" viewBox="0 -3 360 30" width="360" height="38">
                            <text transform="matrix(1 0 0 1 5 10.283)">2</text>
                            <text transform="matrix(1 0 0 1 5 31)">3</text>
                            <line class="a-formula-svg__line" x1="0" y1="15.8" x2="18" y2="15.8"/>
                            <text transform="matrix(1 0 0 1 23.6665 18.9495)">x</text>
                            <text transform="matrix(1 0 0 1 36.6665 19.283)">[ {{currencyFormat(row.formula.deceasedNet) }} + {{ currencyFormat(row.formula.dependantsNet) }} ] - {{ currencyFormat(row.formula.dependantsNet) }}</text>
                        </svg>
                    </td>
                    <td v-if="theMultiplicand.method == 'multiplicand_default' && row.numberOfDependants > 1">
                        <svg version="1.1" x="0px" y="0px" viewBox="0 -3 360 30" width="360" height="38">
                            <text transform="matrix(1 0 0 1 5 18.9495)">75%</text>
                            <text transform="matrix(1 0 0 1 38.6665 18.9495)">x</text>
                            <text transform="matrix(1 0 0 1 48.6665 19.283)">[ {{currencyFormat(row.formula.deceasedNet) }} + {{ currencyFormat(row.formula.dependantsNet) }} ] - {{ currencyFormat(row.formula.dependantsNet) }}</text>
                        </svg>
                    </td>
                    <td v-if="theMultiplicand.method == 'multiplicand_percentage'">
                        <svg version="1.1" x="0px" y="0px" viewBox="0 -3 360 30" width="360" height="38">
                            <text transform="matrix(1 0 0 1 5 18.9495)">{{ theMultiplicand.percentage }}%</text>
                            <text transform="matrix(1 0 0 1 38.6665 18.9495)">x</text>
                            <text transform="matrix(1 0 0 1 48.6665 19.283)">[ {{currencyFormat(row.formula.deceasedNet) }} + {{ currencyFormat(row.formula.dependantsNet) }} ] - {{ currencyFormat(row.formula.dependantsNet) }}</text>
                        </svg>
                    </td>
                    <td>{{ currencyFormat(row.dependencyMultiplicand) }}</td>
                    <td>{{ roundValue(row.multiplier, 3)}}</td>
                    <td>
                        <em>Table&nbsp;{{ row.period=='pre' ? 'E' : 'F' }}&nbsp;</em>&mdash;&nbsp;{{ roundValue(row.discountFactor, 2) }}
                    </td>
                    <td v-if="theDeceased.income.contingencyMultiplier">{{ roundValue(theDeceased.income.multiplier, 2) }}</td>
                    <td>
                        {{ roundValue(row.multiplier, 2)}}&nbsp;x&nbsp;{{roundValue(row.discountFactor,2) }}&nbsp;<span v-if="theDeceased.income.contingencyMultiplier">x&nbsp;{{ roundValue(theDeceased.income.multiplier,2) }}&nbsp;</span>=&nbsp;{{ roundValue(row.discountedMultiplier,2)}}
                    </td>
                    <td>{{ currencyFormat(row.value) }}</td>
                </tr>
                </tbody>
            </table>
        </div>

        <div class="a-table a-table--short-no-style a-table--really-wide" v-else>
            <div :class="{ 'a-loader--table' : !multiplierTable1and2.length }"></div>
            <div v-if="multiplierTable1and2.length">
                <h2 class="a-table--non-white">Pre-Assessment ({{ dateFormat(multiplierTable1and2[0].pre.period_from.date, "DD/MM/YYYY") }}
                    - {{ dateFormat(multiplierTable1and2[0].pre.period_to.date, "DD/MM/YYYY") }})</h2>
                <table cellspacing="0" cellpadding="0" width="100%">
                    <thead>
                    <tr>
                        <th>Period (years)</th>
                        <th>Dependants</th>
                        <th>Table 36</th>
                        <th>Split %</th>
                        <th>Table 1 and 2 </th>
                        <th>Discount Factor</th>
                        <th v-if="theDeceased.income.contingencyMultiplier">Employment Contingency Multiplier</th>
                        <th>Discounted Multiplier</th>
                        <th>Multiplicand</th>
                        <th>Loss</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="period in multiplierTable1and2[0].pre.periods">
                        <td>{{ roundValue(period.period, 2) }}</td>
                        <td>{{ roundValue(period.dependants) }}</td>
                        <td>{{ roundValue(period.table28, 2) }}</td>
                        <td>{{ roundValue(period.split, 2) }}</td>
                        <td>{{ roundValue(period.table1And2, 2) }}</td>
                        <td>{{ roundValue(period.discountFactor, 2) }}</td>
                        <td v-if="theDeceased.income.contingencyMultiplier">{{ theDeceased.income.multiplier }}</td>
                        <td>{{ roundValue(period.discountMultiplier, 2) }}</td>
                        <td>{{ currencyFormat(period.multiplicand) }}</td>
                        <td>{{ currencyFormat(period.loss) }}</td>
                    </tr>
                    </tbody>
                </table>
                <h2 class="a-table--non-white">Post-Assessment ({{ dateFormat(multiplierTable1and2[0].post.period_from.date, "DD/MM/YYYY") }} -
                    {{ dateFormat(multiplierTable1and2[0].post.period_to.date, "DD/MM/YYYY") }})</h2>
                <table cellspacing="0" cellpadding="0" width="100%">
                <thead>
                <tr>
                    <th>Period (years)</th>
                    <th>Dependants</th>
                    <th>Table 36</th>
                    <th>Split %</th>
                    <th>Table 1 and 2 </th>
                    <th>Discount Factor</th>
                    <th v-if="theDeceased.income.contingencyMultiplier">Employment Contingency Multiplier</th>
                    <th>Discounted Multiplier</th>
                    <th>Multiplicand</th>
                    <th>Loss</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="period in multiplierTable1and2[0].post.periods">
                    <td>{{ roundValue(period.period, 2) }}</td>
                    <td>{{ roundValue(period.dependants) }}</td>
                    <td>{{ roundValue(period.table28, 2) }}</td>
                    <td>{{ roundValue(period.split, 2) }}</td>
                    <td>{{ roundValue(period.table1And2, 2) }}</td>
                    <td>{{ roundValue(period.discountFactor, 2) }}</td>
                    <td v-if="theDeceased.income.contingencyMultiplier">{{ roundValue(theDeceased.income.multiplier,2) }}</td>
                    <td>{{ roundValue(period.discountMultiplier, 2) }}</td>
                    <td>{{ currencyFormat(period.multiplicand) }}</td>
                    <td>{{ currencyFormat(period.loss) }}</td>
                </tr>
                </tbody>
            </table>
            </div>
        </div>

        <modal :name="'multipliers_' + uniqueId" no-default-button="true">
            <modal-content></modal-content>
        </modal>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapGetters, mapActions} from 'vuex';
    import roundValue from 'mixins/roundValue';
    import currencyFormat from 'mixins/currencyFormat';
    import Control from 'components/form/Control.vue';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import moment from 'moment';
    import formatServerDate from 'mixins/formatServerDate';
    import dateFormat from 'mixins/dateFormat';
    import Modal from 'components/modal/Modal.vue';
    import ModalContent from 'components/modal/ModalContent.vue';

    export default {
        name: 'multipliers',
        mixins: [currencyFormat, roundValue, formatServerDate, dateFormat],
        components: {
            Control,
            Modal,
            ModalContent
        },
        directives:{
            'two-dp':TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('fatal/dependency/proceduralDates', {
                procDate: 'date'
            }),
            ...mapGetters('fatal/dependency/claimDetails', {
                claimDetails: 'value'
            }),
            ...mapGetters('fatal/dependency/deceased', {
                deceasedDetails: 'value',
                theDeceased: 'theDeceased',
                theDeceasedNetIncome: 'theDeceasedNetIncome',
                theDeceasedGrossIncome: 'theDeceasedGrossIncome',
            }),
            ...mapGetters('fatal/dependency/dependants', [
                'dependantNetIncome',
            ]),
            ...mapGetters('fatal/dependency/dependencyOnIncome', {
                multipliers: 'getAll',
                multiplierTable: 'table28',
                multiplierTable1and2: 'table1and2',
                preDependencyValue: 'preDependencyValue',
                postDependencyValue: 'postDependencyValue'
            }),
            ...mapGetters('fatal/dependency/claimDetails', {
                detailValue: 'value',
            }),
            ...mapGetters('fatal/dependency/multiplicand', {
                multiplicandTotal: 'determineTotal',
                theMultiplicand: 'theMultiplicand'
            }),
            periodSettlementToEnd: {
                get(){
                    return this.multipliers.durationOfDependency;
                },
            },
            discountRate: {
                get() {
                    return this.detailValue('discountRate');
                },
                set(value) {
                    this.updateDetail({key: 'discountRate', value});
                    return this.updateDiscountTable(this.multipliers.discountTable);
                }
            },
            discountTable: {
                get(){
                    return this.multipliers.discountTable;
                },
                set(value){
                    return this.updateDiscountTable(value);
                }
            },
            table1Or2Label: {
                get(){
                    return 'Ogden Table '+(this.theDeceased.gender === 'female' ? 2 : 1)+' Multiplier';
                }
            },
            calculatedIncomeDependency: {
                get(){
                    return this.preDependencyValue + this.postDependencyValue;
                }
            },
            multiplierPayload() {
                return {
                    assumedSettlement: this.claimDetails('assumedSettlement'),
                    person: this.theDeceased,
                    discountRate: this.discountRate,
                    duration: this.periodSettlementToEnd,
                }
            },
            preAndPostAssessmentPayload() {
                return {
                    assumedSettlement: this.claimDetails('assumedSettlement'),
                    person: this.theDeceased,
                }
            },
            uniqueId() {
                return this._uid;
            }
        },
        methods: {
            ...mapActions('fatal/dependency/dependencyOnIncome', [
                'updateDiscountTable',
            ]),
            ...mapActions('fatal/dependency/claimDetails', {
                updateDetail: 'update',
            }),
        }
    }

</script>



// WEBPACK FOOTER //
// Multipliers.vue?44157af3